var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SortableTable',{attrs:{"rows":_vm.allAlerts,"headers":_vm.eventHeaders,"search":false,"table-actions":false,"row-actions":false,"paging":true,"rows-per-page":10,"default-sort-by":"name","key-field":"id"}})
}
var staticRenderFns = []

export { render, staticRenderFns }